export default "__VITE_ASSET__BZQoiX0D__"